module.exports = __webpack_public_path__ + "static/uspto-patent-dd39e4637310b72ae156389564e88315.jpeg";